import { render, staticRenderFns } from "./labelmanage.vue?vue&type=template&id=1b1efefc&scoped=true&"
import script from "./labelmanage.vue?vue&type=script&lang=js&"
export * from "./labelmanage.vue?vue&type=script&lang=js&"
import style0 from "./labelmanage.vue?vue&type=style&index=0&id=1b1efefc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1efefc",
  null
  
)

export default component.exports